<!-- User Info Dilogue -->
<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  class="SSTArabic"
  header="User Data"
  [(visible)]="visible"
  [position]="'center'"
  (onHide)="setState($event)"
  [style]="{ width: '95vw', maxWidth: '1000px' }"
>
  <div dir="rtl" class="px-5 py-2">
    <h4 class="heading SSTAraabic v4-color-white">
      {{ "User details" | translator }}
    </h4>
    <h5 class="online-details SSTAraabic">
      {{ "the name" | translator }} :
      <p class="p">
        {{ user?.name?.first }} {{ user?.name?.middle }} {{ user?.name?.last }}
      </p>
    </h5>
    <h5 class="online-details SSTAraabic">
      {{ "E-mail address" | translator }} :
      <p class="p">{{ user?.email }}</p>
    </h5>
    <h5 class="online-details SSTAraabic">
      {{ "City" | translator }} :
      <p class="p">{{ user?.location.name }}</p>
    </h5>
    <h5 class="online-details SSTAraabic">
      {{ "Mobile Phone Number" | translator }} :
      <p class="p">{{ user?.phone }}</p>
    </h5>
    <h5 class="online-details SSTAraabic">
      {{ "Job title" | translator }} :
      <p class="p">{{ user?.gender }}</p>
    </h5>
  </div>
</p-dialog>
